module.exports = __webpack_public_path__ + "static/media/export-event-challenges.8afcef4a.xlsx";